import './TooltipCmrContent.css'
import { date, list, measure } from '../../../utils/formatter'

export const TooltipCmrContent = ({ data }) => {
  return (
    <table className="tooltip-cmr-content">
      <thead>
        <th colSpan={2}>
          <td>CMR Details</td>
        </th>
      </thead>
      <tbody>
        {data?.vendorAccessNumbers && (
          <tr>
            <td>Appointment number</td>
            <td>{list(data?.vendorAccessNumbers)}</td>
          </tr>
        )}
        {data?.transportHolderIdReferenceNumbers && (
          <tr>
            <td>Trailer ID reference number</td>
            <td>{list(data?.transportHolderIdReferenceNumbers)}</td>
          </tr>
        )}
        {data?.transportHolderNumbers && (
          <tr>
            <td>Trailer number</td>
            <td>{list(data?.transportHolderNumbers)}</td>
          </tr>
        )}
        {data?.transportHolderLicensePlateNumbers && (
          <tr>
            <td>Trailer license plate number</td>
            <td>{list(data?.transportHolderLicensePlateNumbers)}</td>
          </tr>
        )}
        {data?.transportHolderSealNumbers && (
          <tr>
            <td>Trailer seal number</td>
            <td>{list(data?.transportHolderSealNumbers)}</td>
          </tr>
        )}
        {data?.transportHolderTypeSizeCodes && (
          <tr>
            <td>Trailer type size code</td>
            <td>{list(data?.transportHolderTypeSizeCodes)}</td>
          </tr>
        )}
        {data?.calculatedCmrShipmentCount && (
          <tr>
            <td># shipments</td>
            <td>{data?.calculatedCmrShipmentCount}</td>
          </tr>
        )}
        {data?.calculatedCmrGoodsHolderCount && (
          <tr>
            <td># cartons</td>
            <td>{data?.calculatedCmrGoodsHolderCount}</td>
          </tr>
        )}
        {data?.transportHolderGrossVolume && (
          <tr>
            <td>Trailer gross volume</td>
            <td>{measure(data?.transportHolderGrossVolume)}</td>
          </tr>
        )}
        {data?.shippingPointCode && (
          <tr>
            <td>Shipping point</td>
            <td>{data?.shippingPointCode}</td>
          </tr>
        )}
        {data?.plannedShipmentReadyTimestamp && (
          <tr>
            <td>Trailer cut-off</td>
            <td>{date(data?.plannedShipmentReadyTimestamp)}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default TooltipCmrContent
